import {
  takeLatest, put, call, cancel, delay, select,
} from 'redux-saga/effects';
import type { SagaReturnType } from 'redux-saga/effects';

import * as request from 'lib/provider/request';
import { RSVP } from 'lib/provider/requests/invitation';

import * as cardStore from 'store/nodes/card';

import * as actions from '../actions';
import * as selectors from '../selectors';

export const config = {
  action: [
    actions.sendAnswerAttending.type,
    actions.sendAnswerNotAttending.type,
  ],
  method: takeLatest,
};

export function* func(action: SagaReturnType<typeof actions.sendAnswerAttending> | SagaReturnType<typeof actions.sendAnswerNotAttending>) {
  const uuid: string = yield select(cardStore.selectors.getUuid);
  const rsvp: RSVP | null = yield select(selectors.getRSVP);

  if (!uuid || !rsvp) {
    yield put(actions.requestDone(action.type === actions.sendAnswerAttending.type ? 'attending' : 'notAttending'));
    yield cancel(); return;
  }

  if (action.type === actions.sendAnswerNotAttending.type) {
    const response: SagaReturnType<typeof request.invitation.update> = yield call(() => request.invitation.update(uuid, {
      id: rsvp.id,
      eventId: rsvp.eventId,
      status: 'not_attending',
    }));
    if (response.error || !response.data) {
      yield put(actions.requestDone('notAttending'));
      yield cancel(); return;
    }
    yield put(actions.setRSVP(response.data, 'replace'));
  }

  yield put(actions.requestDone(action.type === actions.sendAnswerAttending.type ? 'attending' : 'notAttending'));

  yield delay(10);

  if (action.type === actions.sendAnswerAttending.type) {
    yield put(actions.setStep('info'));
  }

  if (action.type === actions.sendAnswerNotAttending.type) {
    yield put(actions.setStep('note'));
  }
}
